import { render, staticRenderFns } from "./FormularInput.vue?vue&type=template&id=c0a0fa56&v-if=actualformular&"
import script from "./FormularInput.vue?vue&type=script&lang=js&"
export * from "./FormularInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports